import React from 'react';
import { industries } from './homepageContent';

const IndustriesSection = () => (
  <section className="home-industries-section" aria-labelledby="home-industries-title">
    <div className="home-industries-orb home-industries-orb--one" aria-hidden="true"></div>
    <div className="home-industries-orb home-industries-orb--two" aria-hidden="true"></div>
    <div className="auto-container">
      <div className="home-industries-heading">
        <div className="sec-title light">
          <div className="title">CROSS-INDUSTRY EXPERIENCE</div>
          <h2 id="home-industries-title">Industries We&apos;ve Worked With</h2>
        </div>
        <p>
          Our experience spans customer-facing platforms and internal business systems,
          giving us the context to shape technology around how each industry actually works.
        </p>
      </div>

      <div className="home-industry-grid">
        {industries.map((industry) => (
          <article className="home-industry-card" key={industry.name}>
            <span className="home-industry-icon" aria-hidden="true"><i className={`fa ${industry.icon}`}></i></span>
            <h3>{industry.name}</h3>
            <p>{industry.text}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default IndustriesSection;
